import firebase from 'firebase';

var firebaseConfig = JSON.parse(process.env.REACT_APP_FIREBASE);
firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth;
export const firestore = firebase.firestore;
firebase.auth().useDeviceLanguage();
